import { render, staticRenderFns } from "./CustomerAccountTab.html?vue&type=template&id=c3160dc4&scoped=true&"
import script from "./CustomerAccountTab.ts?vue&type=script&lang=ts&"
export * from "./CustomerAccountTab.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerAccountTab.scss?vue&type=style&index=0&id=c3160dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3160dc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
